export default function (props: any) {
    const { num = 1 } = props;
    const numPath: any = {
        1: (
            <path
                d="M37.8 44.12C37.8 35 41.36 29.6 49.36 29.6C57.36 29.6 60.92 35 60.92 44.12C60.92 53.24 57.36 58.64 49.36 58.64C41.36 58.64 37.8 53.24 37.8 44.12ZM49.32 32.96C43 32.96 42.04 39.72 42.04 44.12C42.04 50.48 44.04 55.28 49.36 55.28C54.64 55.28 56.68 50.56 56.68 44.12C56.68 36.96 54.24 32.96 49.32 32.96ZM71.5988 29.44H74.9188V58H70.6788V37.8H62.3187V34.68H63.0388C66.5588 34.68 71.0788 34.04 71.5988 29.48V29.44Z"
                fill="#3F68E0"
            />
        ),
        2: (
            <path
                d="M33.8 44.12C33.8 35 37.36 29.6 45.36 29.6C53.36 29.6 56.92 35 56.92 44.12C56.92 53.24 53.36 58.64 45.36 58.64C37.36 58.64 33.8 53.24 33.8 44.12ZM45.32 32.96C39 32.96 38.04 39.72 38.04 44.12C38.04 50.48 40.04 55.28 45.36 55.28C50.64 55.28 52.68 50.56 52.68 44.12C52.68 36.96 50.24 32.96 45.32 32.96ZM60.5588 39.64C60.5588 33.6 64.0788 29.6 71.5588 29.6C78.7188 29.6 82.0388 33.4 82.0388 38.52C82.0388 48.32 68.4388 47.88 65.1988 54.32H82.0388V58H60.0387C60.8388 45 77.7988 46.6 77.7988 38.48C77.7988 34.76 75.3588 32.96 71.7988 32.96C67.1988 32.96 64.7188 35.32 64.5588 39.64H60.5588Z"
                fill="#3F68E0"
            />
        ),
        3: (
            <path
                d="M33.8 44.12C33.8 35 37.36 29.6 45.36 29.6C53.36 29.6 56.92 35 56.92 44.12C56.92 53.24 53.36 58.64 45.36 58.64C37.36 58.64 33.8 53.24 33.8 44.12ZM45.32 32.96C39 32.96 38.04 39.72 38.04 44.12C38.04 50.48 40.04 55.28 45.36 55.28C50.64 55.28 52.68 50.56 52.68 44.12C52.68 36.96 50.24 32.96 45.32 32.96ZM60.5988 38.8C60.8788 32.72 64.8388 29.6 71.1188 29.6C78.3188 29.6 81.3187 33.28 81.3187 37.24C81.3187 39.84 79.9988 42.2 77.1588 42.96V43.04C80.3188 43.64 82.5588 46.16 82.5588 49.72C82.5588 54.24 79.5588 58.64 71.5588 58.64C64.5188 58.64 59.9588 56.04 59.8788 49.2H63.8788C64.0788 53.24 66.1988 55.28 71.3188 55.28C75.9188 55.28 78.3188 53.12 78.3188 50C78.3188 46.88 75.6388 45 71.2788 45C69.8788 45 69.3588 45.08 68.9588 45.08V41.6C69.5188 41.64 70.2788 41.64 71.4788 41.64C73.2788 41.64 77.0788 41.36 77.0788 37.56C77.0788 34.16 74.2388 32.96 70.9988 32.96C67.0388 32.96 64.7988 34.8 64.5987 38.8H60.5988Z"
                fill="#3F68E0"
            />
        ),
        4: (
            <path
                d="M33.8 44.12C33.8 35 37.36 29.6 45.36 29.6C53.36 29.6 56.92 35 56.92 44.12C56.92 53.24 53.36 58.64 45.36 58.64C37.36 58.64 33.8 53.24 33.8 44.12ZM45.32 32.96C39 32.96 38.04 39.72 38.04 44.12C38.04 50.48 40.04 55.28 45.36 55.28C50.64 55.28 52.68 50.56 52.68 44.12C52.68 36.96 50.24 32.96 45.32 32.96ZM75.2388 29.44H78.7588V47.88H83.6388V51.24H78.7588V58H74.7588V51.24H60.1588V47.56L75.2388 29.44ZM74.7588 35.04H74.6788L64.1588 47.88H74.7588V35.04Z"
                fill="#3F68E0"
            />
        ),
    };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="116" height="86" viewBox="0 0 116 86" fill="none" {...props}>
            <path
                d="M111 22.4701C106.135 15.6209 89.3928 2.87814 57.7399 6.70097C18.0894 11.4897 0.869677 31.9335 7.32231 56.6368C12.4399 76.229 36.8375 85.2296 69.6808 79.096C100.386 73.3617 120.667 49.9468 100.386 25.5762"
                stroke="#3F68E0"
                strokeWidth="4"
                strokeLinecap="round"
            />
            {numPath[num]}
        </svg>
    );
}
